
export class TabakoKlasifikatoriusApi {
  id: any;
  cldvlId!: number;
  kodas: any;
  pavadinimas: any;
  pilnasPavadinimas: any;
  pavadinimasEn: any;
  pilnasPavadinimasEn: any;
  filtroSvoris!: number;
  dateFrom: any;
  dateTo: any;
  pastaba: any;
}
